import { getReportEvent } from './utils';
const report = () => {
    const eventKey = getReportEvent('component');
    if (eventKey) {
        const event = new CustomEvent(eventKey);
        document.dispatchEvent(event);
    }
};
export default report;
